export default __webpack_public_path__ + "static/media/rh-professionals.42c7e7ac.svg";